import { render, staticRenderFns } from "./BoardWriteNoticeLayout.vue?vue&type=template&id=04710722&scoped=true&"
import script from "./BoardWriteNoticeLayout.vue?vue&type=script&lang=js&"
export * from "./BoardWriteNoticeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04710722",
  null
  
)

export default component.exports